// in src/posts.js
import React from 'react';
import Button from '@mui/material/Button';
import { CardActions } from '@mui/material';

import { Filter, DeleteButton, DateField, RichTextField, RefreshButton, SimpleShowLayout, Show, ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, FileField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput, useTheme } from 'react-admin';
import ListQuestionsField from './FieldComponents/ListQuestionsField';
import { OnlyShowActionsDetail } from './FieldComponents/OnlyShowActions';
import { useMediaQuery } from '@mui/material';

const AServiceQualifyFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="issue" alwaysOn />
    </Filter>
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

export const ActionsListServices = ({ basePath, data }) => {
    return (
        <CardActions style={cardActionStyle}>
            <RefreshButton />
            <Button
                variant="contained"
                color="primary"
                href={`${process.env.REACT_APP_SERVERURL}/api/a-services-qualifies/csvexport/xmls`}
                target="_blank"
                download="calificacion-de-servicios.xlsx"
            >
                Exportar Excel
            </Button>
        </CardActions>
    );
};

export const ASQList = (props) => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List
            {...props}
            title="Respuestas - Calificar Servicio"
            actions={<ActionsListServices />}
            filters={<AServiceQualifyFilter />}
        >
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.issue}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <ReferenceField label="Categoría" source="issue" reference="services-qualifies">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="comment" label="Comentario" />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

export const ASQShow = (props) => (
    <Show actions={<OnlyShowActionsDetail />} title="Detalle Calificar Servicio" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <ReferenceField label="Categoría" source="issue" reference="services-qualifies">
                <TextField source="name" />
            </ReferenceField>
            <ListQuestionsField source="questions" label="Preguntas" />
            <TextField source="comment" label="Comentario" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);